import {Conversation} from '@stripe-internal/conversations-client';
import {FullDrawerConfirmation} from '@stripe-internal/conversations-ui';
import {defineMessages} from 'react-intl';

import {BottomDrawerType, useActiveBottomDrawer} from './useActiveBottomDrawer';

const MESSAGES = defineMessages({
  chatTitle: {
    id: 'support_conversations_client.supportWidget.closeConfirmation.chatTitle',
    description:
      'Iinstruction title provided when user intends to close the chat window',
    defaultMessage: 'This will end your support conversation.',
  },
  chatDescription: {
    id: 'support_conversations_client.supportWidget.closeConfirmation.chatDescription',
    description:
      'Instruction description provided when user intends to close the chat window',
    defaultMessage: 'Are you sure you want to exit?',
  },
  chatConfirm: {
    id: 'support_conversations_client.supportWidget.closeConfirmation.chatConfirm',
    description:
      'Text shown for the close chat button when closing support chat window',
    defaultMessage: 'Yes, end chat',
  },
  chatCancel: {
    id: 'support_conversations_client.supportWidget.closeConfirmation.chatCancel',
    description:
      'Text shown for the cancelclose chat button when canceling closing support chat window',
    defaultMessage: 'No, keep chatting',
  },
});

interface Props {
  conversation: Conversation;
  confirmationType: BottomDrawerType | null;
  isOpen: boolean;
  onEndConversation: () => void;
}

export function CloseConfirmationModal({
  conversation,
  confirmationType,
  isOpen,
  onEndConversation,
}: Props) {
  const {closeBottomDrawer} = useActiveBottomDrawer({
    conversation,
  });

  if (confirmationType === 'closeConfirmation') {
    return (
      <FullDrawerConfirmation
        open={isOpen}
        title={MESSAGES.chatTitle}
        description={MESSAGES.chatDescription}
        confirmLabel={MESSAGES.chatConfirm}
        cancelLabel={MESSAGES.chatCancel}
        onConfirm={() => {
          closeBottomDrawer('closeConfirmation');
          onEndConversation();
        }}
        onCancel={() => closeBottomDrawer('closeConfirmation')}
      />
    );
  }

  return null;
}
